import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=704c364a&scoped=true&"
import script from "./PricingView.vue?vue&type=script&lang=js&"
export * from "./PricingView.vue?vue&type=script&lang=js&"
import style0 from "./PricingView.vue?vue&type=style&index=0&id=704c364a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c364a",
  null
  
)

export default component.exports